export class TemplateCurrentState {
    public state: string;
    public args:TemplateCurrentStateArgument[] = [];

    constructor(fields?: Partial<TemplateCurrentState>) {
        if (fields) {
            Object.assign(this, fields);

            if(fields.args) {
                this.args = [];

                for(let curArg of fields.args) {
                    this.args.push(new TemplateCurrentStateArgument(curArg));
                }
            }
        }
    }

    public getArgumentByName(name:string):TemplateCurrentStateArgument {
        let arg:TemplateCurrentStateArgument;

        for(let a of this.args) {
            if(a.name == name) {
                arg = a;
            }
        }

        return arg;
    }
}


export class TemplateCurrentStateArgument {
    public name: string;
    public value:any;

    constructor(fields?: Partial<TemplateCurrentStateArgument>) {
        if (fields) {
            Object.assign(this, fields);
        }
    }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/VyQQATNu/0/groupe-dev/nm17/node_modules/nm-socle-application/app/shared/models/template-current-state.ts